import { render, staticRenderFns } from "./ticketShare.vue?vue&type=template&id=bda9a62a&"
import script from "./ticketShare.vue?vue&type=script&lang=js&"
export * from "./ticketShare.vue?vue&type=script&lang=js&"
import style0 from "./ticketShare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports